import { render, staticRenderFns } from "./RenderCamera.vue?vue&type=template&id=650e7aa0&scoped=true&"
import script from "./RenderCamera.vue?vue&type=script&lang=js&"
export * from "./RenderCamera.vue?vue&type=script&lang=js&"
import style0 from "./RenderCamera.vue?vue&type=style&index=0&id=650e7aa0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650e7aa0",
  null
  
)

export default component.exports